var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count)?_c('div',{staticClass:"items-counter"},[(_vm.suffixText)?[_vm._v(" "+_vm._s(_vm.$t(_vm.suffixText, [_vm.count]))+" ")]:[_vm._v(" "+_vm._s(_vm.$t(_vm.prefixText, [_vm.count]))+" ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }